import { Grid, Stack, Typography, TextField } from "@mui/material";
import { InputControl } from "../../../shared";

export default function CostPerUnitSection({
  ingredient,
  buyingUnits,
  onChange,
  validator,
}) {
  const buyingUnit =
    (buyingUnits?.length > 0 &&
      ingredient?.data?.buying_unit_id &&
      buyingUnits?.find((c) => c?.id === ingredient?.data?.buying_unit_id)) ||
    null;

  return (
    <Grid
      container
      gap="24px"
      py="24px"
      borderBottom="1px solid"
      borderColor="divider"
    >
      <Grid item xs={12} sm={4}>
        <Typography
          variant="subtitle1"
          fontWeight={600}
          sx={{ width: "150px" }}
        >
          Cost per Unit
        </Typography>
        <Typography variant="subtitle2" color="#657083">
          Add cost per UoM, eg: $10/kg
        </Typography>
      </Grid>
      <Grid item flex={1}>
        <Stack
          gap="15px"
          flexDirection="row"
          flexWrap={{ md: "nowrap", xs: "wrap" }}
        >
          <InputControl
            name="buying_unit_id"
            label="Buying Unit"
            required
            fullWidth
            type="dropdown"
            disableClearable
            options={buyingUnits ?? []}
            getOptionLabel={(option) => option?.name}
            value={buyingUnit}
            onChange={(e, newValue) => {
              onChange({
                target: {
                  name: "buying_unit_id",
                  value: newValue?.id,
                },
              });
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Buying Unit"
                required
                error={validator.current.message(
                  "Buying Unit",
                  buyingUnit,
                  "required",
                )}
                helperText={validator.current.message(
                  "Buying Unit",
                  buyingUnit,
                  "required",
                )}
              />
            )}
          />

          <InputControl
            name="cost_exc_tax"
            type="text"
            label="Cost Ex GST"
            required
            fullWidth
            disabled={!ingredient?.data?.tax_group_id}
            error={validator.current.message(
              "Cost Ex GST",
              ingredient?.data?.cost_exc_tax,
              "required",
            )}
            helperText={validator.current.message(
              "Cost Ex GST",
              ingredient?.data?.cost_exc_tax,
              "required",
            )}
            onChange={onChange}
            value={ingredient?.data?.cost_exc_tax}
          />

          <InputControl
            name="cost_inc_tax"
            type="text"
            label="Cost In GST"
            required
            fullWidth
            disabled={!ingredient?.data?.tax_group_id}
            error={validator.current.message(
              "Cost In GST",
              ingredient?.data?.cost_inc_tax,
              "required",
            )}
            helperText={validator.current.message(
              "Cost In GST",
              ingredient?.data?.cost_inc_tax,
              "required",
            )}
            onChange={onChange}
            value={ingredient?.data?.cost_inc_tax}
          />
        </Stack>
      </Grid>
    </Grid>
  );
}
